import React from 'react'
import Yup from '../../../../helpers/custom-yup'
import Button from '../../../../components/buttons/buttons.component'
import MyOrder from './components/my-order.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component.jsx'
import Container from '../../../../components/layout/container.component'
import ShippingAddress from '../../../../components/form-components/shipping-address/shipping-address.component.jsx'
import AccordionSecondary from './../../../../components/accordion/accordion-secondary.component'
import * as config from 'config'
import { Formik } from 'formik'
import { routes } from '../../../../constants/routes.constants'
import { history } from './../../../../helpers/history'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions/toast.actions'
import { bindActionCreators } from 'redux'
import { StyledButtonContainer } from './components/styled-components.component'
import PassengersData from '../../../ticket-sale/components/passengers-data.component'
import { paymentFieldsYupSchema } from '../../../../components/form-components/payment-fields/payment-fields.component.jsx'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'
import PaymentFields, {
	paymentFieldsInitialValues
} from './../../../../components/form-components/payment-fields/payment-fields.component'
import {
	StoreProductService,
	TicketSaleService,
	PassengerService
} from '../../../../services'

import Modal from '../../../../components/modal/modal.component'
import ReactHtmlParser from 'react-html-parser'
import AnchorButton from '../../../../components/buttons/anchor-button.component'
import { ToggleSwitch } from 'react-dragswitch'
import 'react-dragswitch/dist/index.css'
import './style.css'
import PaymentData from '../../../ticket-sale/components/payment-data.component'

const baseUrl = `${config.contentUrl}loja/produto/`

const validationSchema = Yup.object().shape(paymentFieldsYupSchema)

class StoreProductRedeem extends React.Component {
	constructor(props) {
		super(props)
		this.redeem = redeem.bind(this)
		this.onClose = onClose.bind(this)
		this.debitCardModal = debitCardModal.bind(this)
		this.aceitarTermo = aceitarTermo.bind(this)
		this.confirmRedemption = confirmRedemption.bind(this)
		this.onSubmitPassengers = onSubmitPassengers.bind(this)
		this.onSubmitPayment = onSubmitPayment.bind(this)
		this.getAccordionItems = getAccordionItems.bind(this)
		this.state = {
			isOpen: false,
			onClose: false,
			imageUrl: '',
			productName: '',
			shouldRenderModalDebt: false,
			termoAceite: false,
			passengersValues: [],
			passengersDataIsValid: false,
			paymentDataIsValid: false,
			paymentValues: {}
		}
	}

	componentDidMount() {
		const { id } = this.props.match.params
		StoreProductService.getDetails(id).then(({ data }) => {
			const { name, productImages } = data
			const { source } = productImages.find(({ main }) => main)

			this.setState({
				productName: name,
				imageUrl: `${baseUrl}${source}`
			})
		})
	}

	componentWillMount() {
		this.initialValues = {
			...paymentFieldsInitialValues({ installments: true })
		}

		this.props.setPaymentMethod('creditCard')
	}

	render() {
		const {
			shouldRenderModalDebt,
			modalDebitContent,
			isOpen,
			termoAceite
		} = this.state

		return (
			<Container medium>
				<AntiFraud />
				<AccordionSecondary
					arrow={false}
					multiple
					noClickable
					noAnimated
					items={this.getAccordionItems()}
				/>
				<div className="checkAceite">
					<h1>Aceitar termos</h1>
					<p>
						Declaro que li e concordo com os{' '}
						<AnchorButton href="/regulamento" noStyle targetBlank>
							termos e condições de uso
						</AnchorButton>{' '}
						e com o{' '}
						<AnchorButton
							href="/politica-de-privacidade"
							noStyle
							targetBlank>
							termo de privacidade
						</AnchorButton>{' '}
						do programa Muviflex <span className="orange">*</span>
					</p>
					<label>
						<ToggleSwitch
							checked={termoAceite}
							onChange={e => {
								this.aceitarTermo(e)
							}}
							onColor={'#d4622f'}
						/>
						<strong>{termoAceite ? 'Sim' : 'Não'}</strong>
					</label>
				</div>

				<StyledButtonContainer>
					<Button primary type={'button'} onClick={this.confirmRedemption}>
						Confirmar Compra
					</Button>
				</StyledButtonContainer>
				{shouldRenderModalDebt ? (
					<Modal onClose={onClose} isOpen={isOpen}>
						{ReactHtmlParser(modalDebitContent)}
					</Modal>
				) : null}
			</Container>
		)
	}
}

function onSubmitPassengers(passengerValues) {
	const { passengersValues } = this.state

	passengersValues.push(passengerValues)

	this.props.user !== null
		? PassengerService.addPassenger(passengerValues)
		: null

	this.setState({ passengersValues })

	if (passengersValues.length == this.props.qttProducts) {
		this.setState({ passengersDataIsValid: true })
	}
}

function onClose() {
	this.setState({ isOpen: false })
	// clear form
	this.refs.form.resetForm()
}

function aceitarTermo(e) {
	let state = this.state
	if (e) {
		state.termoAceite = true
	} else {
		state.termoAceite = false
	}
	this.setState(state)
}

function onSubmitPayment(paymentValues) {
	this.setState({ paymentValues, paymentDataIsValid: true })
}

async function redeem() {
	const {
		match,
		deviceId,
		toastError,
		hideLoading,
		showLoading,
		userMoveflexNumber
	} = this.props

	const { id: productId } = match.params
	const { selectedPaymentCondition } = this.props.location.state
	const { productName, paymentMethod } = this.state

	let passengersList = []

	this.state.passengersValues.forEach((passenger, idx) => {
		passengersList.push({
			passengerBirthDate: passenger[`passenger_birthdate_${idx}`] || null,
			passengerDocument: passenger.documentnumber || null,
			passengerDocumentType: passenger.documenttype || null,
			passengerName: passenger.name || null
		})
	})

	const params = {
		deviceId,
		quantity: this.props.qttProducts,
		productId,
		paymentConditionId: selectedPaymentCondition.id,
		addressId: this.refs.address.getSelectedAddress().id,
		paymentMethod,
		ProductAddictionalData: passengersList
	}

	const { paymentDataIsValid, paymentValues } = this.state

	if (paymentDataIsValid) {
		const paymentInfo = paymentValues
		const { cardPrintedName } = paymentInfo
		paymentInfo.cardholderName = cardPrintedName

		delete paymentInfo.cardPrintedName

		params.paymentMethod = paymentInfo.paymentMethod
		delete paymentInfo.paymentMethod
		params.paymentInfo = paymentInfo

		if (params.paymentMethod === 'pixLoja') {
			params.paymentMethod = 'pix'
		}

		if (params.paymentMethod === 'pix') {
			paymentInfo.cardBrand = 'mastercard'
			paymentInfo.cardNumber = '0'
			paymentInfo.cardMonthValidity = '0'
			paymentInfo.cardYearValidity = '0'
			paymentInfo.cardholderName = '0'
			paymentInfo.installments = '1'
			paymentInfo.securityCode = '0'
		}
	}

	showLoading()

	try {
		const { errors, success, data } = await StoreProductService.redeem(params)

		hideLoading()

		if (success) {
			const id = `${userMoveflexNumber}x${+new Date()}`
			const { installments } = params.paymentInfo || { installments: 0 }

			window.dataLayer = window.dataLayer || []
			window.dataLayer.push({ ecommerce: null })
			window.dataLayer.push({
				event: 'purchase',
				ecommerce: {
					transaction_id: id,
					value: selectedPaymentCondition.price * params.quantity,
					currency: 'BRL',
					items: [
						{
							item_name: productName,
							item_id: '--',
							price: selectedPaymentCondition.price,
							quantity: params.quantity,
							item_category: 'Loja Muviflex',
							currency: 'BRL',
							points: selectedPaymentCondition.points,
							installments: installments || 0,
							payment_method: params.paymentMethod || ''
						}
					]
				}
			})

			// if params have object debitcard
			if (paymentMethod === 'debitCard') {
				debitCardModal(data)
			}

			history.push(`${routes.CLIENTE}/loja/produto-resgatado`, data)
		} else {
			toastError({
				message:
					(errors && errors.pop()) || 'Não foi possível comprar o produto'
			})
		}
	} catch (error) {
		console.log(erro)
	}
}

function debitCardModal(data) {
	if (data) {
		const { redirect_url, MD, PaReq, TermUrl } = data

		const obj = {
			MD,
			PaReq,
			TermUrl,
			redirectUrl: redirect_url
		}

		TicketSaleService.sendGetNetDebitCard(obj)
			.then(response => {
				if (response.success) {
					this.setState({
						modalDebitContent: response.data,
						shouldRenderModalDebt: true,
						isOpen: true
					})
					hideLoading()
				}
			})
			.catch(console.error)
	}
}

async function confirmRedemption() {
	this.setState({ passengersValues: [] })

	const { toastError } = this.props

	const passengersForms = this.getPassengersForms()

	for (const passengerForm of passengersForms) {
		passengerForm.submitForm()
	}

	await this.getPaymentDataForm.submitForm()

	const { passengersDataIsValid, termoAceite, paymentDataIsValid } = this.state

	const canProceed = passengersDataIsValid && termoAceite && paymentDataIsValid

	if (canProceed) {
		this.redeem()
	} else {
		const message = getWarningMessage(this.state)
		toastError({ message })
	}
}

function getWarningMessage({ passengersDataIsValid, termoAceite }) {
	if (!passengersDataIsValid) return 'Verifique os dados dos passageiros'
	if (!termoAceite) return 'É necessário aceitar os termos e condições'
	if (!this.state.paymentDataIsValid) return 'Verifique os dados de pagamento'
}

function getAccordionItems() {
	const { productName, imageUrl } = this.state
	const { qttProducts } = this.props
	const { id } = this.props.match.params
	const { selectedPaymentCondition } = this.props.location.state

	const sliceIndex = -Math.max(Math.log10(id), 4)
	const productCode = ('000' + id).slice(sliceIndex)
	const { points, price } = selectedPaymentCondition
	const totalPoints = (qttProducts * points).toLocaleString('pt-BR')
	const totalValue = qttProducts * price
	const hasPrice = price > 0

	const items = [
		{
			title: 'Meu pedido',
			initiallyOpened: true,
			content: (
				<MyOrder
					productName={productName}
					productCode={productCode}
					totalPoints={totalPoints}
					totalValue={totalValue}
					imageUrl={imageUrl}
					qttProducts={this.props.qttProducts}
				/>
			)
		},
		{
			title: 'Endereço de entrega',
			initiallyOpened: true,
			content: <ShippingAddress ref={'address'} />
		},
		{
			title: 'Dados do passageiro',
			initiallyOpened: true,
			content: (
				<PassengersData
					onSubmit={this.onSubmitPassengers}
					getFormsRefs={getForms => (this.getPassengersForms = getForms)}
					showPointsMessagePassenger={false}
				/>
			)
		}
	]

	if (hasPrice) {
		items.push({
			title: 'Forma de pagamento',
			initiallyOpened: true,
			content: (
				<PaymentData
					totalValue={totalValue}
					onSubmit={this.onSubmitPayment}
					getFormRef={form => (this.getPaymentDataForm = form)}
				/>
			)
		})
	}

	return items
}

const mapStateToProps = ({ antiFraud, user, productStore }) => ({
	deviceId: antiFraud.sessionID,
	userMoveflexNumber: user.moveflexNumber,
	qttProducts: productStore.qttProducts
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			toastError: toastActions.danger,
			setPaymentMethod: TicketSaleCreators.paymentMethod
		},
		dispatch
	)

const connectedStoreProductRedeem = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(StoreProductRedeem)
)

export { connectedStoreProductRedeem as ModuleRootComponent }
